import { Toaster } from 'sonner';

const TOAST_ICON_CLASS_NAME = 'text-xl leading-none';
const TOAST_ICON_STYLE = { fontFamily: 'Tossface' };

const AppToaster = () => {
	return (
		<Toaster
			position="top-center"
			expand
			visibleToasts={1}
			icons={{
				success: (
					<span className={TOAST_ICON_CLASS_NAME} style={TOAST_ICON_STYLE}>
						😀
					</span>
				),
				warning: (
					<span className={TOAST_ICON_CLASS_NAME} style={TOAST_ICON_STYLE}>
						🤔
					</span>
				),
				error: (
					<span className={TOAST_ICON_CLASS_NAME} style={TOAST_ICON_STYLE}>
						😭
					</span>
				),
			}}
			toastOptions={{
				classNames: {
					toast:
						'w-fit items-center justify-center gap-2 !rounded-full border bg-white !py-3 !px-5 text-center font-pretendard text-mantang-gray-900 shadow-mantang',
					title:
						'whitespace-nowrap text-center font-semibold text-sm leading-5',
					icon: 'size-6',
					content: 'w-fit min-w-max items-center gap-0',
					success: '!border-mantang-primary',
					warning: '!border-mantang-orange',
					error: '!border-mantang-red',
				},
				style: {
					borderRadius: '9999px',
					minWidth: 'max-content',
					width: 'fit-content',
					transform: 'translateX(-50%)',
					left: '50%',
				},
			}}
		/>
	);
};

export default AppToaster;
